"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.get-prototype-of.js");

var _global = _interopRequireDefault(require("global"));

var _ui = require("@storybook/ui");

var _addons = require("@storybook/addons");

var _channelPostmessage = _interopRequireDefault(require("@storybook/channel-postmessage"));

var _channelWebsocket = _interopRequireDefault(require("@storybook/channel-websocket"));

var _coreEvents = _interopRequireDefault(require("@storybook/core-events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FEATURES = _global.default.FEATURES,
    SERVER_CHANNEL_URL = _global.default.SERVER_CHANNEL_URL;

var ReactProvider = /*#__PURE__*/function (_Provider) {
  _inherits(ReactProvider, _Provider);

  var _super = _createSuper(ReactProvider);

  function ReactProvider() {
    var _this;

    _classCallCheck(this, ReactProvider);

    _this = _super.call(this);
    _this.addons = void 0;
    _this.channel = void 0;
    _this.serverChannel = void 0;
    var channel = (0, _channelPostmessage.default)({
      page: 'manager'
    });

    _addons.addons.setChannel(channel);

    channel.emit(_coreEvents.default.CHANNEL_CREATED);
    _this.addons = _addons.addons;
    _this.channel = channel;

    if (FEATURES !== null && FEATURES !== void 0 && FEATURES.storyStoreV7 && SERVER_CHANNEL_URL) {
      var serverChannel = (0, _channelWebsocket.default)({
        url: SERVER_CHANNEL_URL
      });
      _this.serverChannel = serverChannel;

      _addons.addons.setServerChannel(_this.serverChannel);
    }

    return _this;
  }

  _createClass(ReactProvider, [{
    key: "getElements",
    value: function getElements(type) {
      return this.addons.getElements(type);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.addons.getConfig();
    }
  }, {
    key: "handleAPI",
    value: function handleAPI(api) {
      this.addons.loadAddons(api);
    }
  }]);

  return ReactProvider;
}(_ui.Provider);

exports.default = ReactProvider;